import UserLogIn from "../pages/authentication/users/login";
import UserSignup from "../pages/authentication/users/signup";
import ChatbotUI from "../pages/chatbotUi";
import LandingPage from "../pages/landing";
import UserDashboard from "../pages/userDashboard";
import Account from "../pages/userDashboard/Account";
import ChatBot from "../pages/userDashboard/Chatbot";
import Conversations from "../pages/userDashboard/Chatbot/Conversations";
import CreateNewBot from "../pages/userDashboard/Chatbot/screens/createNewBot";
import Dashboard from "../pages/userDashboard/Dashboard";

// interface Route {
//   path: string;
//   Component: React.FC;
//   name?: string;
// }

const routes = [
  {
    path: "/",
    Component: LandingPage,
    name: "Home",
  },
  {
    path: "/auth/user/login",
    Component: UserLogIn,
    name: "User Login",
  },
  {
    path: "/auth/user/signup",
    Component: UserSignup,
    name: "User Signup",
  },
  {
    path: "/user/dashboard",
    Component: UserDashboard,
    name: "User Dashboard",
  },
  {
    path: "/user/chatbots",
    Component: ChatBot,
    name: "User Chatbots",
  },
  {
    path: "/user/dashboard/bot/editBot",
    Component: CreateNewBot,
    name: "Create New Bot",
  },
  {
    path: "/user/account",
    Component: Account,
    name: "User Account",
  },
  {
    path: "/user/chatbot/conversations",
    Component: Conversations,
    name: "Client conversations",
  },
  { path: "/iframe", Component: ChatbotUI, name: "Iframe chatbot ui" },
  { path: "/*", Component: LandingPage, name: "Home" },
];

export default routes;
